// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1O8OZ","item":"PaymentsMobile_item__2ibU5","label":"PaymentsMobile_label__28uCC","amount":"PaymentsMobile_amount__1MQR1"};